import { Auth } from "../auth";
import { API } from "../api";
import { Storage } from "../storage";
import axios from 'axios';
import Cookies from 'js-cookie';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api/research';

function getCsrfToken() {
    return Cookies.get('csrftoken') || '';
}

const adminApiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});

adminApiClient.interceptors.request.use(
    (config) => {
        const csrfToken = getCsrfToken();
        if (csrfToken && ['post', 'put', 'patch', 'delete'].includes(config.method?.toLowerCase())) {
            config.headers['X-CSRFToken'] = csrfToken;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const GetAPIAuthorization = async () => {
  return '';
};

export const AdminGetUser = async (userIdOrUsername) => {
  try {
    const isNumeric = /^\d+$/.test(userIdOrUsername);
    if (isNumeric) {
      const response = await adminApiClient.get(`/admin/user/${userIdOrUsername}/`);
      return response.data;
    } else {
      const response = await adminApiClient.get('/admin/user/', {
        params: { username: userIdOrUsername }
      });
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching user:', error);
    throw error;
  }
};

export const AdminUpdateUserAttributes = async (userIdOrUsername, attributes) => {
  try {
    const userData = {};
    if (attributes.email) userData.email = attributes.email;
    if (attributes.fname || attributes.given_name) userData.fname = attributes.fname || attributes.given_name;
    if (attributes.lname || attributes.family_name) userData.lname = attributes.lname || attributes.family_name;
    if (attributes.phone_number) userData.phone_number = attributes.phone_number;
    if (attributes.institute) userData.institute = attributes.institute;
    if (attributes.research_field) userData.research_field = attributes.research_field;
    if (attributes.research_geo) userData.research_geo = attributes.research_geo;
    if (attributes.contributor_access !== undefined) userData.contributor_access = attributes.contributor_access;
    
    const isNumeric = /^\d+$/.test(userIdOrUsername);
    const requestData = {
      user: userData
    };
    
    if (isNumeric) {
      requestData.id = userIdOrUsername;
    } else {
      requestData.username = userIdOrUsername;
    }
    
    const response = await adminApiClient.post('/admin/user/update/', requestData);
    return response.data;
  } catch (error) {
    console.error('Error updating user attributes:', error);
    throw error;
  }
};

export const SetContributorAccess = async (userIdOrUsername, contributorAccess) => {
  try {
    const isNumeric = /^\d+$/.test(userIdOrUsername);
    const requestData = {
      contributor_access: contributorAccess
    };
    
    if (isNumeric) {
      requestData.id = userIdOrUsername;
    } else {
      requestData.username = userIdOrUsername;
    }
    
    const response = await adminApiClient.post('/admin/user/set-contributor-access/', requestData);
    return response.data;
  } catch (error) {
    console.error('Error setting contributor access:', error);
    throw error;
  }
};

export const s3Remove = async (key) => {
  try {
    await Storage.remove(key);
  } catch (error) {
    console.error('Error removing file:', error);
    throw error;
  }
};

